import { useAuth0 } from "@auth0/auth0-react";
import { InputField, LabelField } from "components";
import { getCurrency } from "helper/numberFormat";
import FinanceService from "Lib/API/Finance";
import React, { useEffect,useMemo, useState } from "react";
import { toastr } from "react-redux-toastr";
import thousands from "thousands";
import { CheckFloatValue } from "../../../../utils/functions";
import { MyCheckbox } from "components";

const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
export const CreditOnAccount=({ formik, ...props }) => {

  const isOptionalObject = useMemo(() => {

    if (

      !Array.isArray(formik["values"]["allPaymentsMethods"]) ||

      formik["values"]["allPaymentsMethods"].length === 0

    )

      return;



    const currentComponent = formik["values"]["allPaymentsMethods"].find(

      (item) => {

        return item.type === "credit on account";

      }

    );



    if (!currentComponent||!currentComponent._id) return;



    return {
      id:currentComponent?._id,
   coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false,
      isOptional: currentComponent?.convenienceFeeInfo?.optional ?? false,

      message: currentComponent?.convenienceFeeInfo?.message,

      type: currentComponent?.type,

    };

  }, [formik["values"]]);

   useEffect(() => {
    if (!isOptionalObject?.isOptional) return;
    if (!key) return;
  
    if (formik.values[key] === undefined) {
      formik.setFieldValue(key, true);
    }
  }, [key, isOptionalObject]);

  const key = `${isOptionalObject?.id}`;



  return (

    <>

      {isOptionalObject?.coverConvenienceFee &&isOptionalObject?.isOptional && ( // Todo:add optional true

        <div

          className="right-side px-0 py-2"

          style={{

                minWidth: "216px",
                   justifyContent: "flex-end",
    display: "flex",
    width: "89%",

          }}

        >

          <div className="d-flex align-items-center">

            <MyCheckbox

              name={key}

              checked={formik.values?.[key]}

              onClick={(e) => {

                formik.setFieldValue(key, e.target.checked);

              }}

            />

            <LabelField

              style={{ display: "flex", alignItems: "center", marginBottom: 0 }}

              title="Convenience Fee"

            />

          </div>

        </div>

      )}

    </>

  );
  };
export const CreditOnAccountHeader = ({ formik, ...props }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { expanded, current } = props;
  const [creditOnAccountAmount, setCreditOnAccountAmount] = useState("");
  const currency = getCurrency();

  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };
  const getCreditOnAccountAmount = async (id) => {
    if (id) {
      const token = await getAccessTokenSilently();
      await FinanceService.getCreditOnAccountAmount(id, token).then((res) => {
        setCreditOnAccountAmount(res?.result?.balance);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }
  };
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num?.toString().replace(/,/g, "")))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    getCreditOnAccountAmount(
      formik?.values?.account_name?.id ?? formik?.values?.accountIds
    );
  }, [formik?.values?.account_name?.id, formik?.values?.accountIds]);

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  return (
    <div
      className={
        expanded === false && current?.includes("credit on account") === true
          ? "accordion-header"
          : expanded === false
            ? "accordion-payment-header"
            : expanded === true
              ? "accordion-header"
              : "accordion-header-payment"
      }
    >
      <div className="d-flex credit-on-account-spacing">
        <LabelField title="Credit On Account" />
        <span
          className={
            expanded === false &&
              current?.includes("credit on account") === true
              ? "creditBalance"
              : "creditOnAccount-title"
          }
        >
          {/* (balance: $
          {creditOnAccountAmount
            ? getCommaSeperatedValue(creditOnAccountAmount)
            : 0}
          ) */}
          (balance: {currency}
          {creditOnAccountAmount
            ? isNaN(creditOnAccountAmount) ? "0.00" : thousands((+creditOnAccountAmount).toFixed(2))
            : 0}
          )
        </span>
      </div>
      <div
        className={
          expanded === false && current?.includes("credit on account")
            ? "custom-expand dollor-icon col-sm-3 nonexpanded-amount"
            : expanded === false &&
              current?.includes("credit on account") === false &&
              formik?.values?.onAccountCredit_payment
              ? "custom-expand dollor-icon col-sm-3 nonexpanded"
              : "col-sm-3"
        }
      >
        {expanded === false &&
          current?.includes("credit on account") &&
          formik?.values?.onAccountCredit_payment ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>
              {/* {getCommaSeperatedValue(formik.values?.onAccountCredit_payment)} */}
              {isNaN(formik.values?.onAccountCredit_payment) ? "0.00" : thousands((+formik.values?.onAccountCredit_payment).toFixed(2))}
            </span>
          </div>
        ) : current?.includes("credit on account") && expanded === true ? (
          <InputField
            {...{
              formik,
              title: "none",
              name: `val`,
              style: { background: "#ffff", border: "none" },
              value: formik.values?.onAccountCredit_payment,
              placeholderIcon: (
                <span
                  className="align-self-center px-4"
                  style={{ color: "black" }}
                >
                  {currency}
                </span>
              ),
            }}
            max={parseInt(creditOnAccountAmount)}
            paymentInput="paymentInput"
            handleFocus={(e) => handlefieldClick(e)}
            // onKeyDown={preventMinus}
            handleChange={(event) => {
              formik.setFieldValue(
                "onAccountCredit_payment",
                event.target.value.match(regex)[0]
              );
              formik.setFieldValue(
                "creditOnAccountAmount",
                creditOnAccountAmount
                  ? thousands((+creditOnAccountAmount).toFixed(2))
                  : 0
              );
            }}
          />
        ) : expanded === false &&
          current?.includes("credit on account") === false &&
          formik?.values?.onAccountCredit_payment ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>
              {/* {getCommaSeperatedValue(formik.values?.onAccountCredit_payment)} */}
              {isNaN(formik.values?.onAccountCredit_payment) ? "0.00" : thousands((+formik.values?.onAccountCredit_payment).toFixed(2))}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
